import React from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PageBreadcrumb from '@/components/common/PageBreadCrumb';
import PageMeta from '@/components/common/PageMeta';
import CarReportForm from '@/features/cars/components/CarReportForm';
import { useQueryClient } from '@tanstack/react-query';
import { rentingsApi } from '@/features/rentings/api/rentingsApi';
import { useQuery } from '@tanstack/react-query';

const CreateReportPage: React.FC = () => {
  const { id: rentingId } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  // Используем getRentingDetails для получения полных данных с activities
  const { data: renting, isLoading, error } = useQuery({
    queryKey: ['renting-details', rentingId],
    queryFn: () => rentingsApi.getRentingDetails(rentingId!),
    enabled: !!rentingId,
  });

  // Получаем тип отчета из query параметров
  const reportType = searchParams.get('type') as 'delivery_to_client' | 'pickup_from_client' | null;

  if (isLoading) {
    return <div>{t('Loading...')}</div>;
  }

  if (error || !renting) {
    return <div>{t('Error loading renting')}</div>;
  }

  const handleSubmit = () => {
    queryClient.invalidateQueries({ queryKey: ['reports', rentingId] });
    navigate(`/rentings/${rentingId}`);
  };

  const handleClose = () => {
    navigate(`/rentings/${rentingId}`);
  };

  return (
    <>
      <PageMeta
        title={`${t('cars.report.create.title')} | Admin.Drivitive`}
        description={t('cars.report.create.description')}
      />
      <PageBreadcrumb
        items={[
          { label: t('nav.rentings'), path: '/rentings' },
          { label: `${t('rentings.breadcrumb.renting')} #${renting.number}`, path: `/rentings/${rentingId}` },
          { label: t('cars.report.create.title') },
        ]}
      />

      <div className="mx-auto">
        <CarReportForm
          carId={renting.car.id}
          rentingId={rentingId}
          activities={renting.activities}
          initialReportType={reportType || undefined}
          onSubmit={handleSubmit}
          onClose={handleClose}
        />
      </div>
    </>
  );
};

export default CreateReportPage;
